import React, { useState } from 'react';
import { Modal } from './ui/Modal';
const NAV_LINKS = [{
  label: 'El Problema',
  href: '#lead'
}, {
  label: 'Por qué funciona',
  href: '#mechanism'
}, {
  label: 'Qué incluye',
  href: '#includes'
}, {
  label: 'Historia',
  href: '#story'
}, {
  label: 'Inversión',
  href: '#investment'
}, {
  label: 'Preguntas',
  href: '#faq'
}];
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="bg-charcoal-dark border-t border-charcoal-light py-12" data-id="element-77" data-mp="398xsbsbb070">
      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center text-center" data-id="element-78" data-mp="3lem1u9lawtp9">
        <div className="mb-6" data-id="element-79" data-mp="3lgosmvua2qv1">
          <h2 className="text-2xl font-heading font-bold tracking-[0.2em] text-offwhite" data-id="element-80" data-mp="3qcnkiteter07">
            ELEV<span className="text-sand" data-id="element-81" data-mp="29ynmjnzj5bfl">ATE</span>
          </h2>
          <p className="text-offwhite-dim/60 mt-2 text-sm uppercase tracking-wider" data-id="element-82" data-mp="2a1jm1gr10865">
            Por Matías Sena
          </p>
        </div>

        <p className="text-sand font-medium italic mb-10" data-id="element-83" data-mp="3l8qwa43iojrg">
          "Cuando volvés a vos, tu casa lo siente."
        </p>

        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-offwhite-dim mb-8" data-id="element-84" data-mp="3gbqx8d534h9u">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="hover:text-sand transition-colors" data-id="element-85" data-mp="3q8mz400ha55f">
              {link.label}
            </a>)}
        </nav>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-offwhite-dim/50 mb-8" data-id="element-86" data-mp="34gvzesy8n6j">
          <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-sand transition-colors" data-id="element-87" data-mp="htd1b43mfm3g">
            Política de Privacidad
          </button>
          <button onClick={() => setIsTermsOpen(true)} className="hover:text-sand transition-colors" data-id="element-88" data-mp="qt8h5m84g59t">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-xs text-offwhite-dim/30" data-id="element-89" data-mp="tvmrhl25amnh">
          © {new Date().getFullYear()} Matías Sena. Todos los derechos
          reservados.
        </p>
      </div>

      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Política de Privacidad" data-id="element-90" data-mp="yrv00flu7hlo">
        <p data-id="element-91" data-mp="18k94hg4av2bj">
          En ELEVATE respetamos tu privacidad y nos comprometemos a proteger tus
          datos personales. Esta política describe cómo recopilamos, usamos y
          protegemos la información que nos proporcionás.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-92" data-mp="1hiulh6u4i9a7">
          1. Información que recopilamos
        </h3>
        <p data-id="element-93" data-mp="1mhpfz61gdma5">
          Solo recopilamos la información necesaria para coordinar la llamada de
          diagnóstico y el acompañamiento del programa: nombre, correo
          electrónico y número de teléfono.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-94" data-mp="3t9yijqx6ik36">
          2. Uso de la información
        </h3>
        <p data-id="element-95" data-mp="2aevh21mn04a0">
          Tu información se utiliza exclusivamente para agendar sesiones,
          enviarte el material personalizado del programa y mantener el
          seguimiento durante las 12 semanas.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-96" data-mp="21m0jzv7bpevb">
          3. Protección de datos
        </h3>
        <p data-id="element-97" data-mp="1worybkmyuspb">
          Todo lo conversado en las sesiones es estrictamente confidencial. No
          compartimos, vendemos ni alquilamos tu información personal a terceros
          bajo ninguna circunstancia.
        </p>
      </Modal>

      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Términos y Condiciones" data-id="element-98" data-mp="2pd608bh6e965">
        <p data-id="element-99" data-mp="2fegnsy81tgxa">Al inscribirte en ELEVATE aceptás los siguientes términos:</p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-100" data-mp="2fgb39x0jwgtz">
          1. Naturaleza del programa
        </h3>
        <p data-id="element-101" data-mp="18vrzvxt88ke3">
          ELEVATE es un programa de coaching y acompañamiento personal de 12
          semanas. No reemplaza el consejo médico, psicológico o psiquiátrico
          profesional, ni constituye diagnóstico o tratamiento. Consultá siempre
          a un profesional de la salud antes de iniciar cualquier cambio de
          dieta o entrenamiento.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-102" data-mp="2iwm7o5bzqp1l">
          2. Inversión y garantía
        </h3>
        <p data-id="element-103" data-mp="2nue0d1kgmf6u">
          La inversión del programa completo es de $1.200 USD por 12 semanas. Si
          durante las primeras dos semanas realizás los ejercicios asignados y
          no percibís movimiento, se reintegra el monto abonado sin preguntas.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-104" data-mp="31khh5d0klgow">3. Compromiso</h3>
        <p data-id="element-105" data-mp="36kdn3hstvi73">
          El resultado depende de tu participación: una sesión semanal de
          aproximadamente 55 minutos y los ejercicios diarios. Las sesiones no
          asistidas sin aviso previo de 24 horas se consideran realizadas.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-106" data-mp="1v6rypyuslkmm">
          4. Propiedad intelectual
        </h3>
        <p data-id="element-107" data-mp="1nk4oj1t9tks8">
          Todo el material entregado (documentos, ejercicios y metodologías) es
          propiedad intelectual de Matías Sena y es para tu uso personal
          exclusivo. Queda prohibida su distribución o venta.
        </p>
      </Modal>
    </footer>;
}